import type { PackageResourceResponse } from "@southfields-digital/mxmz-resource-model";
import api from "src/services/graphicsApi";

/** Fetch the package-level Resources for a graphics package. */
export const getPackageResources = async (
	packageId: string,
): Promise<PackageResourceResponse[]> => {
	const response = await api.get(`/graphicpackages/${packageId}/resources`);

	return response?.data ?? [];
};
